// extracted by css-extract-rspack-plugin
export default {"root":"root-LfGGqG","primary":"primary-wLGQxQ","danger":"danger-UB4cRY","s":"s-nVMQWa","sqr":"sqr-Y7ZV_G"};